window.addEventListener("load", () => {
  const dropdownBtn = document.getElementById("article-type-dropdown-button");
  const dropdownMenu = document.getElementById("article-type-dropdown-menu");
  const dropdownClear = document.getElementById("dropdown-clear");
  if (!dropdownClear) return;
  const dropdownArrow = document.getElementById("article-type-dropdown-arrow");
  const dropdownContainer = document.getElementById(
    "article-type-dropdown-container",
  );
  const searchInput = document.getElementById("news-search");
  const searchButton = document.getElementById("search-button");
  const newsCardsContainer = document.getElementById("news-cards-container");
  const loadingSpinner = document.getElementById("loadingSpinner");
  const loadMoreBtn = document.getElementById("news-results-load-more-btn");
  const searchClear = document.getElementById("search-clear");
  const searchIconWrapper = document.getElementById("search-icon-wrapper");
  function toggleSearchIcons() {
    if (searchInput.value.length > 0) {
      searchClear.classList.remove("hidden");
      searchIconWrapper.classList.add("hidden");
    } else {
      searchClear.classList.add("hidden");
      searchIconWrapper.classList.remove("hidden");
    }
  }
  function toggleDropdownIcons() {
    if (selectedTypes.size > 0) {
      dropdownClear.classList.remove("hidden");
      dropdownArrow.classList.add("hidden");
    } else {
      dropdownClear.classList.add("hidden");
      dropdownArrow.classList.remove("hidden");
    }
  }

  let selectedTypes = new Set();
  let debounceTimer;
  let allArticles = [];
  let displayedArticles = [];
  let currentPage = 1;
  let perPage = 6;
  let totalFound = 0;
  let allLoaded = false;
  function showLoading(show) {
    if (show) {
      loadingSpinner.classList.remove("hidden");
      newsCardsContainer.classList.add("hidden");
      loadMoreBtn.style.display = "none";
    } else {
      loadingSpinner.classList.add("hidden");
      newsCardsContainer.classList.remove("hidden");
    }
  }
  function updateCheckboxUI(slug, isSelected) {
    const btn = document.querySelector(
      `.article-type-filter-btn[data-term-slug="${slug}"]`,
    );
    if (!btn) return;
    const box = btn.querySelector(".checkbox-box");
    const check = btn.querySelector(".checkmark");
    if (isSelected) {
      box.classList.add("bg-brand-dark-red", "border-brand-dark-red");
      box.classList.remove("bg-white", "border-brand-warm-gray");
      check.classList.remove("hidden");
    } else {
      box.classList.remove("bg-brand-dark-red", "border-brand-dark-red");
      box.classList.add("bg-white", "border-brand-warm-gray");
      check.classList.add("hidden");
    }
  }

  async function fetchNews(search = "", articleTypes = [], page = 1) {
    try {
      let filterBy = "";
      if (articleTypes.length > 0) {
        filterBy = articleTypes
          .map((type) => `article_types_slugs:=[${type}]`)
          .join(" || ");
      }
      const params = new URLSearchParams({
        q: search || "*",
        query_by: "title,post_title,content,text,date,article_types_names",
        per_page: perPage,
        page,
      });
      if (search) {
        params.append("num_typos", 0);
        params.append("drop_tokens_threshold", 0);
        params.append("infix", "off");
        params.append("prefix", "false");
      }
      if (filterBy) params.append("filter_by", filterBy);

      const response = await fetch(
        `${envConfig.TYPESENSE_BASE_URL}:${envConfig.TYPESENSE_PORT}/collections/news/documents/search?${params}`,
        {
          headers: {
            "Content-Type": "application/json",
            "X-TYPESENSE-API-KEY": envConfig.TYPESENSE_SEARCH_ONLY_KEY,
          },
        },
      );
      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Error fetching news:", error);
      return { hits: [], found: 0 };
    }
  }
  function renderNews(articles, append = false) {
    if (!articles || articles.length === 0) {
      newsCardsContainer.innerHTML =
        '<div class="col-span-full text-center py-12 text-brand-black text-xl">We couldn\'t find any news that match your search — please try again.</div>';
      loadMoreBtn.style.display = "none";
      return;
    }
    const displayLimit = Math.min(perPage * currentPage, articles.length);
    const articlesToShow = articles.slice(
      displayedArticles?.length,
      displayLimit,
    );
    let html = "";
    articlesToShow.forEach((article) => {
      const doc = article?.document;
      const featuredImage = doc?.featured_image
        ? doc?.featured_image
        : "http://bpa-staging.3lanemarketing.com/wp-content/uploads/2025/07/cropped-favicon2-192x192-1.jpg";
      let articleTypes = doc?.article_types_names
        ? Array.isArray(doc.article_types_names)
          ? doc.article_types_names
          : [doc.article_types_names]
        : [];
      const tagsHtml = articleTypes.length
        ? `<div class="flex flex-wrap gap-2 mb-3">${articleTypes.map((type) => `<div class="px-[.375rem] py-[.1875rem] rounded-[.25rem] bg-brand-light-blue text-center font-neutraface text-brand-dark-blue font-normal text-[.8125rem] leading-[1.375rem] uppercase">${type}</div>`).join("")}</div>`
        : "";
      const title = doc?.title || doc?.post_title || "Untitled";
      const formattedDate = doc?.date || "";
      const permalink = doc?.permalink || doc?.url || "#";

      html += `
      <a href="${permalink}" class="news-card gridBox-three h-full transform transition-transform duration-300 ease-in-out hover:scale-[1.02]">
        <div class="flex flex-col h-full">
          <div class="shrink-0 h-[17.875rem] w-full overflow-hidden bg-brand-light-blue border-b-[.5rem] border-brand-warm-beige">
            <img src="${featuredImage}" class="h-full w-full object-contain object-center" alt="${title}">
          </div>
          <div class="p-6 bg-white flex flex-col gap-3 h-full">
            ${tagsHtml}
            <div class="flex flex-col justify-between h-full gap-3">
              <h3 class="!text-h3 font-normal text-brand-dark-blue">${title}</h3>
              ${formattedDate ? `<div class="font-neutraface text-[1.25rem] leading-[1.5625rem] font-normal text-brand-black">${formattedDate}</div>` : ""}
            </div>
          </div>
        </div>
      </a>
      `;
    });
    if (append) newsCardsContainer.insertAdjacentHTML("beforeend", html);
    else newsCardsContainer.innerHTML = html;
    displayedArticles = articles.slice(0, displayLimit);
    if (displayedArticles.length >= totalFound && totalFound > perPage) {
      loadMoreBtn.style.display = "block";
      loadMoreBtn.textContent = "Show Less";
      allLoaded = true;
    } else if (displayedArticles.length < totalFound) {
      loadMoreBtn.style.display = "block";
      loadMoreBtn.textContent = "Load More";
      allLoaded = false;
    } else {
      loadMoreBtn.style.display = "none";
    }
  }
  async function updateNewsHandler(
    reset = true,
    append = false,
    type = "search",
  ) {
    if (type === "search") showLoading(true);
    if (reset) {
      currentPage = 1;
      allArticles = [];
      displayedArticles = [];
      allLoaded = false;
    }
    const searchTerm = searchInput.value.trim();
    const data = await fetchNews(
      searchTerm,
      Array.from(selectedTypes),
      currentPage,
    );
    totalFound = data.found || 0;
    if (reset) allArticles = data.hits || [];
    else allArticles = [...allArticles, ...(data.hits || [])];
    if (type === "search") showLoading(false);
    renderNews(allArticles, append);
  }
  function handleLoadMore() {
    if (allLoaded) {
      currentPage = 1;
      updateNewsHandler(true, false, "loadMore");
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      currentPage++;
      updateNewsHandler(false, true, "loadMore");
    }
  }
  const filterBtns = document.querySelectorAll(".article-type-filter-btn");
  dropdownClear.addEventListener("click", (e) => {
    e.stopPropagation();
    selectedTypes.clear();
    const allFilterBtns = document.querySelectorAll(".article-type-filter-btn");
    allFilterBtns.forEach((btn) => {
      const slug = btn.getAttribute("data-term-slug");
      updateCheckboxUI(slug, false);
    });
    document.getElementById("dropdown-label").textContent =
      "Filter by Article Type";
    toggleDropdownIcons();
    updateNewsHandler(true, false, "search");
  });

  filterBtns.forEach((btn) => {
    btn.addEventListener("click", (e) => {
      e.stopPropagation();
      const slug = btn.getAttribute("data-term-slug");
      const isSelected = selectedTypes.has(slug);
      if (isSelected) selectedTypes.delete(slug);
      else selectedTypes.add(slug);

      updateCheckboxUI(slug, !isSelected);
      const dropdownLabel = document.getElementById("dropdown-label");
      dropdownLabel.textContent =
        selectedTypes.size > 0
          ? `${selectedTypes.size} Filter${selectedTypes.size > 1 ? "s" : ""} Applied`
          : "Filter by Article Type";
      toggleDropdownIcons();
      updateNewsHandler(true, false, "search");
    });
  });
  searchClear.addEventListener("click", () => {
    searchInput.value = "";
    toggleSearchIcons();
    updateNewsHandler(true, false, "search");
    searchInput.focus();
  });
  searchInput?.addEventListener("input", () => {
    toggleSearchIcons();
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(
      () => updateNewsHandler(true, false, "search"),
      300,
    );
  });
  searchInput?.addEventListener("keypress", (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      updateNewsHandler(true, false, "search");
    }
  });
  searchButton?.addEventListener("click", () =>
    updateNewsHandler(true, false, "search"),
  );
  loadMoreBtn?.addEventListener("click", handleLoadMore);
  dropdownBtn?.addEventListener("click", (e) => {
    e.stopPropagation();
    dropdownMenu.classList.toggle("hidden");
    dropdownArrow.classList.toggle("rotate-180");
  });

  document.addEventListener("click", (e) => {
    if (dropdownContainer && !dropdownContainer.contains(e.target)) {
      dropdownMenu.classList.add("hidden");
      dropdownArrow.classList.remove("rotate-180");
    }
  });
  updateNewsHandler(true, false, "search");
});
